import { Routes } from "@angular/router";
import { revenueManagerGuard } from "../focl/guards/revenue-manager.guard";

import { revenueManagerResolver } from "../focl/pages/revenue-manager/revenue-manager.resolver";

export const featureRoutes: Routes = [
  { path: '', redirectTo: '/pages/revenue-manager', pathMatch: 'full' },
  {
    path: 'revenue-manager',
    resolve: { items: revenueManagerResolver },
    canActivate: [revenueManagerGuard],
    loadComponent: () =>
      import('../focl/pages/revenue-manager/revenue-container/revenue-container.component').then(
        (m) => m.RevenueContainerComponent,
      ),
  },
];
